import React from 'react'
import R from 'ramda'
import {FormattedMessage} from 'react-intl'
import I18nSelect from './I18nSelect'
import selectionProps from '../utils/selectionProps'

const EstateTypeField = ({estateTypes, options, onChange}) => {
  return <I18nSelect
          placeholder={<FormattedMessage id="Estate type" defaultMessage="Estate type"/>}
          className='estate-type'
          labelKey='name'
          valueKey='id'
          options={R.tail(options.estateTypes)}
          value={estateTypes}
          onChange={selectionProps('id', onChange)}
          resetValue={[]}
          multi={true}/>
}

EstateTypeField.propTypes = {
  estateTypes: React.PropTypes.array.isRequired,
  options: React.PropTypes.shape({
    estateTypes: React.PropTypes.array.isRequired,
  }).isRequired,
  onChange: React.PropTypes.func.isRequired,
}

export default EstateTypeField



/** WEBPACK FOOTER **
 ** ./app/components/EstateTypeField.jsx
 **/